export default "__VITE_ASSET__DMv$n6je__"